/* Auto Obrazy — jediný formátovač ceny pre celý JavaScript témy.
   Musí dávať presne rovnaký výstup ako snippets/ao-money.liquid,
   inak sa formát meny mení priamo pred očami zákazníka (napr. keď JS
   po pridaní do košíka prepíše serverom vykreslenú cenu). */
(function (root) {
  'use strict';
  var NBSP = ' ';

  function currencyCode() {
    return (root.AOPageContext && root.AOPageContext.currency) || 'EUR';
  }

  function symbolFor(code) {
    switch (code) {
      case 'EUR': return '€';
      case 'CZK': return 'Kč';
      case 'USD': return '$';
      case 'GBP': return '£';
      default: return code;
    }
  }

  /* cents → "24,99 €" (nezlomiteľná medzera, slovenský formát) */
  function format(cents, options) {
    var opts = options || {};
    var code = opts.currency || currencyCode();
    var value = Number(cents);
    if (!isFinite(value)) value = 0;
    var amount = (Math.round(value) / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    var decimals = parts[1];
    if (opts.trimZeros && decimals === '00') {
      return whole + NBSP + symbolFor(code);
    }
    return whole + ',' + decimals + NBSP + symbolFor(code);
  }

  root.AOMoney = { format: format, symbol: symbolFor, NBSP: NBSP };
})(typeof window !== 'undefined' ? window : globalThis);
